
import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ParteProps } from '../../interfaces/recepcion/ParteInterface';

import { AgregarPartesExhortoRecibidoParams, BuscarExhortoRecibidoAnteriorParams, BuscarExhortoRecibidoParams, BuscarExhortoRecibidoResponse, defaultExhortoRecibidoAnteriorResponse, defaultExhortoRecibidoResponse, defaultGenerarCaratulaExhorto, EditarExhortoRecibidoParams, ExhortoRecibidoAnteriorResponse, GenerarCaratulaExhortoResponse, GuardarExhortoRecibidoAnteriorParams } from '../../interfaces/recepcion/ExhortoRecibidoInterface';

export const BuscarExhortoRecibido = ( params: BuscarExhortoRecibidoParams ) => {

    return new Promise<BuscarExhortoRecibidoResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExhortoRecibido/BuscarExhortoRecibido', params, token)
            .then( ({ data } : { data : BuscarExhortoRecibidoResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultExhortoRecibidoResponse });
            });

        }

    });

}

export const BuscarExhortoRecibidoAnterior = ( params: BuscarExhortoRecibidoAnteriorParams ) => {

    return new Promise<ExhortoRecibidoAnteriorResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExhortoRecibido/BuscarExhortoRecibidoAnterior', params, token)
            .then( ({ data } : { data : ExhortoRecibidoAnteriorResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultExhortoRecibidoAnteriorResponse });
            });

        }

    });

}

export const GuardarExhortoRecibidoAnterior = ( params: GuardarExhortoRecibidoAnteriorParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExhortoRecibido/GuardarExhortoRecibidoAnterior', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const EditarExhortoRecibido = ( params: EditarExhortoRecibidoParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExhortoRecibido/EditarExhortoRecibido', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerPartesExhortoRecibido = ( id: number ) => {

    return new Promise<ParteProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/ExhortoRecibido/ObtenerPartesExhortoRecibido/${ id }`, token)
            .then( ({ data } : { data : ParteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarPartesExhortoRecibido = ( params: AgregarPartesExhortoRecibidoParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExhortoRecibido/AgregarPartesExhortoRecibido', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const GenerarCaratulaExhorto = ( idExhortoRecibido: number ) => {

    return new Promise<GenerarCaratulaExhortoResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/ExhortoRecibido/GenerarCaratula/${ idExhortoRecibido }`, token)
            .then( ({ data } : { data : GenerarCaratulaExhortoResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultGenerarCaratulaExhorto, message: error.message } );
            });

        }

    });

}

export const EliminarCaratulaExhorto = ( idExhortoRecibido: number ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/ExhortoRecibido/EliminarCaratula/${ idExhortoRecibido }`, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}
